import { render } from "./EditUserRole.vue?vue&type=template&id=3f0864d5&scoped=true"
import script from "./EditUserRole.vue?vue&type=script&lang=js"
export * from "./EditUserRole.vue?vue&type=script&lang=js"

import "./EditUserRole.vue?vue&type=style&index=0&id=3f0864d5&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0864d5"]])

export default __exports__